import React, { useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import styles from './resetSuccess.module.css'
import { Back } from '../../../Svg';
import { useNavigate } from 'react-router-dom';

const ResetSuccess = () => {
    const navigate = useNavigate()
    return (
        <>
            <div className={styles.loginContainer}>
                <div className={styles.loginInner}>

                    <div className={styles.loginCol1} onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
                        <img src='/assets/logo.png' />
                    </div>
                    <div className={styles.loginCol2}>
                        <div className={styles.loginCard}>

                            <div className={styles.loginContent}>
                                <h3>Password reset successfully!</h3>
                                <p>Your password has been reset successfully!</p>
                                <button type="submit" className={styles.loginButton} onClick={()=>navigate('/login')}>Login Now</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ResetSuccess